import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adm-acm',
  templateUrl: './adm-acm.component.html',
  styleUrls: ['./adm-acm.component.scss']
})
export class AdmAcmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
